function initializeSwipers() {
  var swipers = [];
  document.querySelectorAll('.swiper-container').forEach(function (container) {
    // Find the closest section wrapper to scope the slides within it
    var sectionWrapper = container.closest('.section-our-story-products-carousel--wrapper');
    var sectionId = sectionWrapper.getAttribute('id'); // Assume each section wrapper has a unique ID

    var swiper = new Swiper(container, {
      slidesPerView: 1.25,
      spaceBetween: 16,
      navigation: {
        nextEl: '#' + sectionId + ' .swiper-button-next',
        prevEl: '#' + sectionId + ' .swiper-button-prev',
      },
      pagination: {
        el: '#' + sectionId + ' .swiper-pagination',
        clickable: true,
        renderBullet: function (index, className) {
          return '<span class="' + className + '">' + (index + 1) + '</span>';
        },
      },
      breakpoints: {
        640: {
          slidesPerView: 1.25,
          spaceBetween: 16,
        },
        768: {
          slidesPerView: 2.25,
          spaceBetween: 20,
        },
        1024: {
          slidesPerView: 4,
          spaceBetween: 24,
        },
      },
    });
    swipers.push(swiper);
  });
  return swipers;
}

document.addEventListener('DOMContentLoaded', function () {
  var swipers = initializeSwipers();

  document.addEventListener('shopify:section:load', function () {
    swipers.forEach(function (swiper) {
      swiper.destroy(true, true);
    });
    swipers = initializeSwipers();
  });

  document.addEventListener('shopify:section:unload', function () {
    swipers.forEach(function (swiper) {
      swiper.destroy(true, true);
    });
  });
});
